import { overlapCheck, TimeFunction } from "@/common/datetime/TimeFunction";
import { AppointmentInfo, ResourceInfo } from "@/services";
import { EventBufferEnum, EventStatusEnum, ITimeLineEvent } from "../Models";

export function getRandomChar(str: string) {
  return str.charAt(Math.floor(Math.random() * str.length));
}

export function shuffle(text: string) {
  const array: string[] = text.split("");
  let currentIndex: number = array.length,
    randomIndex: number;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array.join("");
}

export function generateP(options?: string[], length?: number): string {
  const groups: string[] = options ?? [
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "abcdefghijklmnopqrstuvwxyz",
    "1234567890",
    "!@#$%^&()_+~`|}{[]:;?><,./-=",
  ];
  const lengthTemp: number = length || 8;
  let pass: string = groups.map(getRandomChar).join("");

  const str = groups.join("");

  for (let i = pass.length; i <= lengthTemp; i++) {
    pass += getRandomChar(str);
  }
  return shuffle(pass);
}

export function generateCId(): string {
  const arrStringRandom: string[] = [
    "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    "abcdefghijklmnopqrstuvwxyz",
    "1234567890",
  ];
  return `${generateP(arrStringRandom, 8)}-${generateP(
    arrStringRandom,
    4
  )}-${generateP(arrStringRandom, 4)}-${generateP(arrStringRandom, 12)}`;
}

export function buildEventList(
  timeSlider: Date,
  resource: ResourceInfo,
  dateTimeSelected?: { startTime: Date; endTime: Date }
): ITimeLineEvent[] {
  let _events: ITimeLineEvent[];
  let listEventPrev: ITimeLineEvent[] = [];

  if (TimeFunction.isEveningMidnight(timeSlider)) {
    const newData = (resource?.permission.appointments || [])?.map(
      (slot: AppointmentInfo) => {
        return {
          id: slot.guid,
          start: slot.startTime.dateTime,
          end: slot.startTime.dateTime,
          bufferStatus: checkBuffer(slot?.preBufferTime, slot?.postBufferTime),
          timelineStatus: EventStatusEnum.Busy,
          subject: slot.subject,
          postBufferTime: slot.postBufferTime,
          preBufferTime: slot.preBufferTime,
          workspaceInfo: undefined,
          organizerEmail: slot.organizer.address,
        } as ITimeLineEvent;
      }
    );
    if (newData) {
      listEventPrev = newData;
    }
  }

  _events = (resource?.permission.appointments || [])?.map(
    (slot: AppointmentInfo) => {
      return {
        id: slot.guid,
        start: slot.startTime.dateTime,
        end: slot.endTime.dateTime,
        bufferStatus: checkBuffer(slot?.preBufferTime, slot?.postBufferTime),
        timelineStatus: EventStatusEnum.Busy,
        subject: slot.subject,
        postBufferTime: slot.postBufferTime,
        preBufferTime: slot.preBufferTime,
        workspaceInfo: undefined,
        organizerEmail: slot.organizer.address,
      } as ITimeLineEvent;
    }
  );

  if (listEventPrev.length > 0) {
    _events = [...listEventPrev, ..._events];
  }

  if (!_events) {
    _events = [];
  }
  //handle workspace information, need to do later
  _events = rebuildListTimeLine(_events, timeSlider, dateTimeSelected);

  return _events;
}

const checkBuffer = (pre: number, post: number) => {
  if (pre > 0 && post > 0) {
    return EventBufferEnum.Buffer;
  }

  if (pre > 0 && post === 0) {
    return EventBufferEnum.BufferStart;
  }
  if (pre === 0 && post > 0) {
    return EventBufferEnum.BufferEnd;
  }

  return EventBufferEnum.NoneBuffer;
};

const rebuildListTimeLine = (
  listTimeBusy: Array<ITimeLineEvent>,
  currentDate: Date,
  dateTimeSelected?: { startTime: Date; endTime: Date }
): ITimeLineEvent[] => {
  const newListTimeBusy = new Array<ITimeLineEvent>();
  listTimeBusy.forEach((t) => {
    if (t.id) {
      const timeBusyParent: ITimeLineEvent = {} as ITimeLineEvent;
      timeBusyParent.end = t.end;
      timeBusyParent.start = t.start;
      timeBusyParent.organizerEmail = t.organizerEmail;
      timeBusyParent.subject = t.subject;
      timeBusyParent.id = t.id;
      timeBusyParent.postBufferTime = t.postBufferTime;
      timeBusyParent.preBufferTime = t.preBufferTime;
      if (t.workspaceInfo) {
        const wsInfo = t.workspaceInfo;
        timeBusyParent.workspaceInfo = {
          attendees: wsInfo.attendees ? wsInfo.attendees.map((att) => att) : [],
          available: wsInfo.available,
          capacity: wsInfo.capacity,
          currentAttendees: wsInfo.currentAttendees,
          isSelf: wsInfo.isSelf,
          maxOfLocationCapacity: wsInfo.maxOfLocationCapacity,
          noOfAttendees: wsInfo.noOfAttendees,
          remaining: wsInfo.remaining,
          totalCapacity: wsInfo.totalCapacity,
          transparent: wsInfo.transparent,
          isFakeTimeSlot: wsInfo.isFakeTimeSlot,
        };
      }
      const timeToCheck = new Date(timeBusyParent.end.getTime());
      timeToCheck.setSeconds(timeToCheck.getSeconds() - 1);
      const currentDateClone = new Date(currentDate);
      currentDateClone.setHours(currentDateClone.getHours() -1)
      
      if (timeBusyParent.start < timeBusyParent.end) {
        if (
          !timeBusyParent.id ||
          (timeBusyParent.id &&
            (timeBusyParent.start.getDate() == currentDate.getDate() ||
              currentDate.getDate() == timeToCheck.getDate())) ||
          (dateTimeSelected &&
            ((currentDate >= dateTimeSelected.startTime &&
            currentDate <= dateTimeSelected.endTime) || (currentDateClone >= dateTimeSelected.startTime &&
              currentDateClone <= dateTimeSelected.endTime)) &&
            overlapCheck(
              dateTimeSelected.startTime,
              dateTimeSelected.endTime,
              timeBusyParent.start,
              timeBusyParent.end
            ))
        ) {
          newListTimeBusy.push(timeBusyParent);
        }
      }
    } else {
      newListTimeBusy.push(t);
    }
  });
  return newListTimeBusy;
};
